import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=13aa41e6&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=ts"
export * from "./AddAddress.vue?vue&type=script&lang=ts"
import style0 from "./AddAddress.vue?vue&type=style&index=0&id=13aa41e6&prod&lang=css"
import style1 from "./AddAddress.vue?vue&type=style&index=1&id=13aa41e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa41e6",
  null
  
)

export default component.exports